import "./style/index.css";
import Loading from './Loading';
export default Loading;
export { Loading };